var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_6543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0974 27.2218C14.4354 27.1521 13.1846 27.0895 12.4158 26.9258C11.8957 26.8171 11.4437 26.5756 11.1123 26.2255C10.8562 25.9605 10.6525 25.5561 10.4944 24.9951C10.3589 24.5278 10.3061 24.1389 10.2308 23.189C10.1156 21.0453 10.0881 19.2927 10.2308 17.3344C10.3485 16.2529 10.4056 14.9691 11.1876 14.2201C11.5568 13.8696 11.9863 13.644 12.4686 13.5508C13.2221 13.403 16.4321 13.2861 19.7552 13.2861C23.0707 13.2861 26.2879 13.403 27.042 13.5508C27.6446 13.6676 28.2096 14.0178 28.5414 14.4693C29.2549 15.6289 29.2674 17.0708 29.3398 18.1987C29.3698 18.7361 29.3698 21.7877 29.3398 22.3251C29.2271 24.1076 29.1365 24.7382 28.8803 25.3921C28.7219 25.8049 28.5867 26.0228 28.3527 26.2642C27.9857 26.6357 27.5178 26.8828 27.0113 26.9726C23.8424 27.2188 21.1515 27.2723 18.0974 27.2218ZM22.9502 20.0593C21.1871 19.0859 19.499 18.1832 17.7734 17.2488V22.8389C19.5893 21.819 21.5036 20.8846 22.9577 20.0516L22.9502 20.0593Z",
    fill: "#E14242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_6543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.375,
    fill: "white",
    transform: "translate(10.001 13.125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.50900b6b57b69dfb1ae310cc64b18716.svg";
export { ForwardRef as ReactComponent };